import { Box, Typography } from "@mui/material";
import { colors } from "../../../../theme/palette";
import { EmptyListFigure } from "../../../../assets/icons/MUI/EventsIcons";
import { useTranslation } from "react-i18next";

const EmptyGroupsListFigure = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
    >
      <EmptyListFigure />
      <Typography
        variant="body14Regular"
        sx={{
          color: colors.Dark600,
        }}
      >
        {t("pages.events.createEvent.noGroupsCreated")}
      </Typography>
      <Typography
        variant="body14Regular"
        sx={{
          color: colors.Dark600,
        }}
      >
        {t("pages.events.createEvent.createGroupFromProfile")}
      </Typography>
    </Box>
  );
};

export default EmptyGroupsListFigure;
